module.exports = __webpack_public_path__ + "img/accessory_pants_01.1e488fe1.svg";